import { Component, type ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { error: Error | null; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div style={{
          height: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: 'var(--vs0, #0d1117)', color: 'var(--shell-muted, #c9d1d9)',
          gap: 16, padding: 32, textAlign: 'center',
        }}>
          <div style={{ fontSize: '2rem' }}>⚠️</div>
          <div style={{ fontSize: '1rem', fontWeight: 700 }}>Something went wrong</div>
          <div style={{
            fontSize: '0.78rem', color: 'var(--shell-xs, #8b949e)',
            maxWidth: 480, wordBreak: 'break-word',
          }}>
            {error.message}
          </div>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              marginTop: 8, padding: '8px 20px',
              background: 'var(--v1, #1d9e75)', color: 'var(--text-on-accent)',
              border: 'none', borderRadius: 4, cursor: 'pointer',
              fontSize: '0.82rem', fontWeight: 600,
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
